import script from "./RouletteRacetrack.vue?vue&type=script&setup=true&lang=js"
export * from "./RouletteRacetrack.vue?vue&type=script&setup=true&lang=js"

import "./RouletteRacetrack.vue?vue&type=style&index=0&id=b864b202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b864b202"]])

export default __exports__